import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {originalOrder} from "../../../../../_util/utils";

import {OutsideClickDirective} from 'src/app/_directives/outside-click.directive';
import {SpriteVersionDirective} from 'src/app/_directives/spriteVersionDirective';

@Component({
    selector: 'app-simple-selector',
    templateUrl: './simple-selector.component.html',
    styleUrls: ['./simple-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [OutsideClickDirective, SpriteVersionDirective]
})
export class SimpleSelectorComponent{
  @Input()
  set optionsMap(value: Map<number, string>) {
    if(value) {
      this._optionsMap = new Map(value);
      this.optionsFromKeysList = [];
      this._optionsMap.forEach((optionValue) => this.optionsFromKeysList.push(optionValue))
    }
  }
  get optionsMap() {
    return this._optionsMap
  }
  @Input()
  set selectedOption(value: number) {
    this._selectedOption = value;
  }

  get selectedOption() {
    return this._selectedOption;
  }
  @Output() changeEl: EventEmitter<any> = new EventEmitter<any>()
  @Output() close: EventEmitter<any> = new EventEmitter<any>()

  private _optionsMap = new Map<number, string>()
  private _selectedOption: number;
  optionsFromKeysList: string[] = [];

  closeSelect() {
    this.close.emit()
  }

  protected readonly originalOrder = originalOrder;
}
